// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { goodPathOrSiteName } from 'helpers/regex'

import { INVALID_NAME_VALUE } from 'errors'

// validate path name
export const validatePathName = (pathName, error) => {
  if (pathName.length > 43) {
    error.pathName = 'Path Name cannot be longer than 43 characters.'
  } else if (pathName.length && !goodPathOrSiteName.test(pathName)) {
    error.pathName = INVALID_NAME_VALUE
  }
}
